export default class AiChatQuestion {
  readonly id: number
  readonly icon: string
  readonly title: string
  // readonly image: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.icon = data.icon
    this.title = data.title
    // this.image = data.image
  }
}
